import "./HeroimgStyles.css";
import React from 'react';
import IntroImg from "../assets/programming-593312_1920.jpeg";
import { Link } from "react-router-dom";
const Heroimg = () => {
    return (
        <div className="hero">
            <div className="mask">
                <img className="intro-img" src={IntroImg} alt="IntroImg" />
            </div>
            <div className="content">
                <p>Hi, MYSELF RISHAV RANJAN.</p>
                <h1>Full Stack Web Developer</h1>
                <div>
                    <Link to="/project" className="btn">PROJECTS</Link>
                    <Link to="/contact" className="btn btn-light">CONTACT</Link>
                </div>
            </div>
        </div>
    )
};
export default Heroimg;
